import axios from 'axios';

export const getOrdersAPI = ({page, limit}) => axios.get(`{server}/admin/orders?page=${page}&limit=${limit}`).then(res => res.data.success)